import '@lottiefiles/lottie-player'
import api from '@/plugins/api'
import lang from '@/plugins/lang'
import { convertFormDataToObject } from '@/plugins/api/converter'
import '@/plugins/jquery.steps'
import { createChoice } from '@/plugins/choices'
import { HighlightFormInvalid, clearHighlightFormError } from '@/plugins/api/highlight_form_invalid'
import setupTimezone from '@/components/select-timezone'
import { bindAllLabelInput } from '@/components/label-input'
import { Swal } from '@/plugins/sweetalert2'
import { getParentElement, waitDOMContentLoaded } from '@/helpers/DOM'
import { doneLoading } from '@/components/page-loading'
import CustomChoiceValue from '@/components/CustomChoiceValue'

function getActionButton(action) {
    return containerActions.querySelector(`a[href="#${action}"]`)
}

function setLoadingButton(action, isLoading) {
    const actionButton = getActionButton(action).parentElement

    if (isLoading) {
        actionButton.classList.add('loading')
        containerActions.classList.add('disabled')
    } else {
        actionButton.classList.remove('loading')
        containerActions.classList.remove('disabled')
    }
}

async function formSubmit() {
    setLoadingButton('finish', true)
    clearHighlightFormError(form)

    try {
        await grecaptcha.ready
        form.querySelector('#recaptcha_token').value = await grecaptcha.execute(process.env.MIX_GOOGLE_CAPTCHA_PUBLIC_KEY)
    } catch (error) {
        Swal.fire({
            title: lang.t('error_http:recaptcha.alert_title'),
            text: lang.t('error_http:recaptcha.alert_body'),
            icon: 'error',
        })

        setLoadingButton('finish', false)

        throw error
    }

    try {
        await api('register', {
            method: 'POST',
            data: new FormData(form),
            withPrefix: false,
        }).finally(() => setLoadingButton('finish', false))
    } catch (error) {
        if (error.status === 422) {
            handlerFormInvalid.highlightForm(error.data.errors, form)

            const firstInputError = handlerFormInvalid.getFirstInputError()

            if (firstInputError) {
                const currentIdx = registerSteps.steps('getCurrentIndex')
                let idx = getParentStepIndex(firstInputError)

                for (;idx < currentIdx; idx++) {
                    registerSteps.steps('previous')
                }

                firstInputError.focus()
            }

            customChoiceOrgType.displayMessageError()
        }

        throw error
    }

    modalRegisterSuccess.modal('show')
}

/**
 * @param input
 * @return {number}
 */
function getParentStepIndex(input) {
    return parseInt(getParentElement(input, 'section').id.slice(-1))
}

const form = document.getElementById('form-register')

/** @type {CustomChoiceValue|null} */
let customChoiceOrgType = null

let stepsValidated = []

let handlerFormInvalid = new HighlightFormInvalid(false)

const stepsValidation = {
    0: async function() {
        clearHighlightFormError(form)

        try {
            let { user } = convertFormDataToObject(new FormData(form))

            let { name, email, phone, password, password_confirmation } = user

            await api('register/pre-validation', {
                method: 'POST',
                data: { user: { name, email, phone, password, password_confirmation } }
            })
        } catch (error) {
            if (error.status === 422) {
                handlerFormInvalid.highlightForm(error.data.errors, form)
            }

            throw error
        }
    },
}

const modalRegisterSuccess = $('#modal-register-success')
    .on('hide.bs.modal', function() {
        window.location.href = '/panel-agent/billing/plans'
    })
    .on('shown.bs.modal', function() {
        this.querySelector('.animation-header').play()
        this.querySelector('.animation-success').play()
    })

const registerSteps = $(form).children('div').steps({
    headerTag: 'h3',
    bodyTag: 'section',
    transitionEffect: 'slideLeft',
    titleTemplate: '<span class="number">#index#</span><span class="title">#title#</span>',
    labels: lang.t('jquery_steps:labels', { returnObjects: true }),
    onInit() {
        createChoice(form.querySelector('[name="user[lang]"]'))
        createChoice(form.querySelector('[name="user[timezone]"]'))

        const choiceOrgType = createChoice(form.querySelector('[name="select_org_type"]'))

        customChoiceOrgType = new CustomChoiceValue(choiceOrgType, 'tenant[org_type]')
        customChoiceOrgType.setup()

        setupTimezone('user[timezone]')

        bindAllLabelInput()
    },
    onFinished(event, currentIndex) {
        const inputAgreed = form.querySelector('[name="agreed_document"]')

        if (!inputAgreed.reportValidity || inputAgreed.reportValidity()) {
            formSubmit()
        }
    },
    onStepChanging(event, currentIdx, newIdx) {
        if (containerActions.classList.contains('disabled')) {
            return false
        }

        if (newIdx > currentIdx && !stepsValidated.includes(currentIdx)) {
            setLoadingButton('next', true)

            stepsValidation[currentIdx]()
                .finally(() => setLoadingButton('next', false))
                .then(() => {
                    stepsValidated.push(currentIdx)
                    registerSteps.steps('next')
                })

            return false
        }

        this.classList.add('overflow-hidden')

        const currentEl = this.querySelector(`#${event.handleObj.namespace}-p-${currentIdx}`)

        currentEl.classList.add('position-absolute')

        if (newIdx < currentIdx) {
            currentEl.style.display = 'none'
        }

        return true
    },
    onStepChanged(event, newIdx, oldIdx) {
        this.classList.remove('overflow-hidden')

        this.querySelector(`#${event.handleObj.namespace}-p-${oldIdx}`).classList.remove('position-absolute')

        let inputFocus

        switch (newIdx) {
            case 0: inputFocus = 'user[name]'
                break
            case 1: inputFocus = 'tenant[name]'
                break
        }

        form.querySelector(`[name="${inputFocus}"]`).focus()
    },
})

const containerActions = form.querySelector('.wizard .actions')

// Caso o usuário volte o step e altere algum valor, remove o step do stepsValidated para realizar a validação novamente
form.querySelectorAll('input, select')
    .forEach(input => {
        input.addEventListener('change', function(event) {
            const stepIdx = getParentStepIndex(event.target)

            stepsValidated = stepsValidated.filter(step => step !== stepIdx)
        })
    })

// Caso aperte enter, chama o proximo passo ou submit
registerSteps[0].addEventListener("keyup", event => {
    event.which === 13 && registerSteps.steps(getActionButton('next').parentElement.classList.contains('disabled') ? 'finish' : 'next')
})

waitDOMContentLoaded().then(async () => {
    await doneLoading()

    form.querySelector('[name="user[name]"]').focus()
})
